const FONT_SIZE = 16;
const valueToUnits = (value, to = "rem", from = "rem", fontSize = FONT_SIZE) => {
  if (from === to) {
    return `${value}${to}`;
  }
  if (from === "rem" && to === "px") {
    return `${value * fontSize}px`;
  }
  if (from === "px" && to === "rem") {
    return `${value / fontSize}rem`;
  }
  return `${value}`;
};
const applyUnitsToAll = (object, to = "rem", from = "rem", fontSize = FONT_SIZE) => {
  const newObject = {};
  Object.keys(object).forEach((key) => {
    newObject[key] = valueToUnits(object[key] ?? 0, to, from, fontSize);
  });
  return newObject;
};
export {
  applyUnitsToAll,
  valueToUnits
};
